<template>
  <div>
    <input
      type="hidden"
      :class="'form-control ' + input.class"
      :value="value"
      @input="(e) => handleChange(e)"
      :placeholder="input.placeholder"
      :required="!input.optional"
      :disabled="input.disabled"
      :name="input.name"
    />
  </div>
</template>
<script>
export default {
  name: "InputHidden",
  components: {},
  props: {
    input: Object,
    value: String,
  },
  data: function() {
    return {};
  },
  methods: {
    handleChange(e) {
      this.$emit("handleChange", e);
    },
  },
};
</script>
